import { memo, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

interface CopyToClipboardProps {
  text: string | undefined | null;  label?: string;
  className?: string;
  iconClassName?: string;
  showLabel?: boolean;
}

const CopyToClipboard = memo(function CopyToClipboard({
  text,
  label = "Copy",
  className = "",
  iconClassName = "",
  showLabel = false,
}: CopyToClipboardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!text) return;

    navigator.clipboard
      .writeText(text)
      .then(() => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);
      });
  };

  if (!text) {
    return <span className="text-neutral-400">N/A</span>;
  }

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <span className="break-all">{text}</span>
      <Tooltip title={copied ? "Copied!" : label} placement="top">
        <IconButton
          onClick={handleCopy}
          size="small"
          className={`p-0 text-neutral-400 hover:text-neutral-600 ${iconClassName}`}
        >
          {copied ? (
            <CheckCircleIcon className="h-4 w-4 text-green-500" />
          ) : (
            <ContentCopyIcon className="h-4 w-4" />
          )}
        </IconButton>
      </Tooltip>
    </div>
  );
});

export default CopyToClipboard;